import axios from "axios";
import io from 'socket.io-client';

const development = (process.env.NODE_ENV === 'development')
const SERVER = development ? "http://localhost:81" : location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
//const SERVER = development ? "http://127.0.0.1:81" : location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
console.log("SERVER", SERVER, development);
const Axios = axios.create();

Axios.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem("jwt");
        if (token) {
            config.headers["x-access-token"] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

function _arrayBufferToBase64(buffer) {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

export const API = {
    getSocket() {
        console.log("getSocket", SERVER);
        return io(SERVER); // , { transports: ['websocket'], upgrade: false }
    },
    async test(par) {
        try {
            let response = await Axios.get(`${SERVER}/test`, {
                params: {
                    test: par,
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getTree(cod, spare) {
        let response = await Axios.get(`${SERVER}/getTree`, {
            params: {
                cod, spare
            },
        });
        console.log("responsetree", response)
        // devo rendere univoci gli id_elemento altrimenti il controllo si incasina
        let cache = []
        let k = 0
        for (let el of response.data) {
            let ie = el.id_elemento
            if (cache[ie]) {
                el.id_elemento += "_" + k++
            }
            cache[ie] = true
        }
        return response;
    },
    async createRequest() {
        let response = await Axios.get(`${SERVER}/createRequest`, {
            params: {},
        });
        return response.data;
    },
    async addRequestItem(reqId,codice,descrizione,urgente,qta){
        let response = await Axios.post(`${SERVER}/addRequestItem`, {reqId,codice,descrizione,urgente,qta});
        return response.data;
    },
    async logsdetail(ts,login){
        let response = await Axios.get(`${SERVER}/logsdetail`, {
            params: { ts, login },
        });
        return response.data;
    },
    async getTabella(tbl, filter) {
        console.log("getTabella", tbl);
        let response = await Axios.get(`${SERVER}/getTabella`, {
            params: {
                tbl, filter
            },
        });
        return response.data;
    },
    async navlog(path) {
        if(path) {
            let response = await Axios.get(`${SERVER}/navlog`, {
                params: {
                    path
                },
            });
            return response.data;
        } else {
            return null
        }
    },
    async getDDT(value) {
        let response = await Axios.get(`${SERVER}/getDDT`, {
            params: {
                value
            },
            responseType: "blob"
        });
        return response.data;
    },
    async getRepPDF(value) {
        let response = await Axios.get(`${SERVER}/getRepPDF`, {
            params: {
                value
            },
            responseType: "blob"
        });
        return response.data;
    },
    async getReportPDF(value) {
        let response = await Axios.get(`${SERVER}/getReportPDF`, {
            params: {
                value
            },
            responseType: "blob"
        });
        return response.data;
    },
    async isReportPDF(value) {
        let response = await Axios.get(`${SERVER}/isReportPDF`, {
            params: {
                value
            },
        });
        return response.data;
    },
    async setTabella(tbl, dato, upd, pkey) {
        console.log("setTabella", tbl, dato, upd, pkey);
        // se è la tabella delle possible units la primary key è "code"
        if(tbl=="possible_units")
            pkey="code"
        let response = await Axios.post(`${SERVER}/setTabella`, {
            tbl,
            dato,
            upd,
            pkey
        });
        return response;
    },
    async delTabella(tbl, pkey, id) {
        console.log("delTabella", tbl, pkey, id);
        let response = await Axios.post(`${SERVER}/delTabella`, {
            tbl,
            pkey,
            id
        });
        return response;
    },
    async totalAssistanceHours(mcode,col) {
        // console.log("totalAssistanceHours", mcode, col);
        let response = await Axios.get(`${SERVER}/totalAssistanceHours`, {
            params: {
                mcode, col
            },
        });
        return response.data;
    },
    async totalAssistanceHoursByType(mcode) {
        // console.log("totalAssistanceHoursByType", mcode);
        let response = await Axios.get(`${SERVER}/totalAssistanceHoursByType`, {
            params: {
                mcode
            },
        });
        return response.data;
    },
    async totalNumTicketAss(mcode, field,byYear) {
        // console.log("totalNumTicketAss", mcode);
        let response = await Axios.get(`${SERVER}/totalNumTicketAss`, {
            params: {
                mcode, field, byYear
            },
        });
        return response.data;
    },
    async lastTickets(limit, mcode) {
        let response = await Axios.get(`${SERVER}/lastTickets`, {
            params: {
                limit,
                mcode
            },
        });
        return response.data;
    },
    async get3Davailable(k) {
        try {
            let response = await Axios.get(`${SERVER}/3Davailable`, {
                params: { k },
            });
            return response.data;
        } catch (error) {
            return null            
        }
    },
    async get3Dname(k) {
        try {
            let response = await Axios.get(`${SERVER}/get3Dname`, {
                params: { k },
            });
            return response.data;
        } catch (error) {
            return null            
        }
    },
    async getHMAP(k) {
        try { 
            let response = await Axios.get(`${SERVER}/2DmapH?k=${k}`);
            return response.data;
        } catch (error) {
            return null            
        }
    },
    async get2Dmap(k) {
        try {
            let response = await Axios.get(`${SERVER}/2Dmap`, {
                params: { k },
            });
            return response.data;
        } catch (error) {
            return null            
        }
    },
    async getPrivacy() {
        try {
            let response = await Axios.get(`${SERVER}/privacy`, {
                params: {},
            });
            return response.data;
        } catch (error) {
            return null            
        }
    },
    async setPrivacy(set) {
        try {
            const response = await Axios.post(`${SERVER}/privacy`, {set});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getAlerts() {
        let response = await Axios.get(`${SERVER}/getAlerts`, {
            params: {},
        });
        return response.data;
    },
    async getClientName() {
        let response = await Axios.get(`${SERVER}/clientName`, {
            params: {},
        });
        return response.data;
    },
    async setAlert(id, viewed) {
        let response = await Axios.get(`${SERVER}/setAlert`, {
            params: {
                id,
                op: viewed ? 'view' : 'delete'
            },
        });
        return response.data;
    },
    async unitImage(unitCode) {
        let response = await Axios.get(`${SERVER}/unitImage`, {
            responseType: "arraybuffer",
            params: {
                unitCode
            },
        });
        return _arrayBufferToBase64(response.data);
    },
    async diaryImage(unitCode,img) {
        let response = await Axios.get(`${SERVER}/diaryImage`, {
            responseType: "arraybuffer",
            params: {
                unitCode,img
            },
        });
        return _arrayBufferToBase64(response.data);
    },
    async unitInfo(unitCode) {
        let response = await Axios.get(`${SERVER}/unitInfo`, {
            params: {
                unitCode
            },
        });
        return response.data;
    },
    async getUnits(all, status) {
        try {
			let units = null
            console.log("getUnits1",all)
			try {
				units = JSON.parse(localStorage.getItem("UNITS"+status))	
			} catch (error) { 
				// non c'è
			}
            console.log("getUnits2",units)
			if(units && units[all || false])
				return units[all || false]
			if(!units) units = {}
            let pars = { params: { status }}
            if (all) {
                pars.params.all = all
            }
            console.log("getUnits3",pars)
            let response = await Axios.get(`${SERVER}/units`, pars);
			if(response.data) {
				units[all || false] = response.data
				localStorage.setItem("UNITS"+status,JSON.stringify(units))
			}
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getUnitstatus(unitCode) {
        try {
            let response = await Axios.get(`${SERVER}/unitstatus`, { params: { unitCode }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getPrInUnits(status,byteam) {
        try {
            let response = await Axios.get(`${SERVER}/pi_units`, { params: { status,byteam }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getPossibleUnits() {
        try {
            let response = await Axios.get(`${SERVER}/possibleunits`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getTemplates() {
        try {
            let response = await Axios.get(`${SERVER}/mc_templates`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getAssStato(id) {
        try {
            let response = await Axios.get(`${SERVER}/getAssStato`, { params: { id }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async reminders(del) {
        try {
            let response = await Axios.get(`${SERVER}/reminders`, { params: { del }, });
            return response;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getAssistance(unitCode) {
        try {
            let response = await Axios.get(`${SERVER}/assistance`, { params: { unitCode }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getRequests() {
        try {
            let response = await Axios.get(`${SERVER}/getRequests`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async takeInCharge(reqid) {
        try {
            let response = await Axios.get(`${SERVER}/takeInCharge`, { params: { reqid }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getRequestDetail(reqid) {
        try {
            let response = await Axios.get(`${SERVER}/getRequestDetail`, { params: { reqid }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async closingTime() {
        try {
            let response = await Axios.get(`${SERVER}/closingTime`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async updateRequestDetail(rowId, dettRows) {
        try {
            let response = await Axios.post(`${SERVER}/updateRequestDetail`, { rowId, dettRows });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async sendRequest(rowId) {
        try {
            let response = await Axios.post(`${SERVER}/sendRequest`, { rowId });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async savememo(due_date, message,subject) {
        try {
            const response = await Axios.post(`${SERVER}/savememo`, {due_date, message,subject});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async chgpass(oldpass, newpass) {
        try {
            const response = await Axios.post(`${SERVER}/chgpass`, {
                oldpass,
                newpass,
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async login(user, password, macchine) {
        try {
			localStorage.removeItem("UNITS") // la cache
			localStorage.removeItem("UNITSproduction") // la cache
			localStorage.removeItem("UNITSinstallation") // la cache
			localStorage.removeItem("UNITSservicecare") // la cache
			localStorage.removeItem("UNITSundefined") // la cache
            const response = await Axios.post(`${SERVER}/login`, { user, password, macchine });
            response.data.password = password
            return response.data;
        } catch (e) {
            // console.error("ERR:", e);
        }
    },
    async getPromoDests(id){
        try {
            let response = await Axios.get(`${SERVER}/promoDests`, {
                params: { id },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async rld(name, surname, company, email, phone){
        try {
            const response = await Axios.post(`${SERVER}/sendmail`, {
                to: "RLD",
                subj: "MyMarsilli Login Data Request",
                text: `${name}, ${surname}, ${company}, ${email}, ${phone}`,
                html: `<h1>New Login Data Request from</h1><p>name: ${name}</p><p>surname: ${surname}</p><p>company: ${company}</p><p>email: ${email}</p><p>phone: ${phone}</p>`
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
            return "ERR";
        }
    },
    async sendmail(to, subj, text, html, xlsx) {
        try {
            const response = await Axios.post(`${SERVER}/sendmail`, {
                to,
                subj,
                text,
                html,
                xlsx
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
            return "ERR";
        }
    },
    async sendTicket(data) {
        try {
            const response = await Axios.post(`${SERVER}/sendTicket`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async sendAskRepair(data) {
        try {
            const response = await Axios.post(`${SERVER}/sendAskRepair`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async sendDiary(data) {
        try {
            const response = await Axios.post(`${SERVER}/sendDiary`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async delPromoImage(image){
        try {
            const response = await Axios.get(`${SERVER}/delPromoImage`, {
                params: {
                    image
                }
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async uploadImage(data) {
        try {
            const response = await Axios.post(`${SERVER}/uploadImage`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async uploadDocument(data) {
        try {
            const response = await Axios.post(`${SERVER}/uploadDocument`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async uploadBackup(data) {
        try {
            const response = await Axios.post(`${SERVER}/uploadBackup`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
            return false
        }
    },
	async getBackupComment(path){
        try {
            const response = await Axios.get(`${SERVER}/backupComment`, {
                params: { path }
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
	},
    async getSpares(code, spare) { // machine Code, optional
        try {
            const response = await Axios.get(`${SERVER}/getSpares`, {
                params: {
                    code, spare
                }
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getSparesServer(params) {
        try {
            console.log("getSparesServer", params,SERVER);
            let pars = { request: params.request }
            pars.request.spareFilter = params.spareFilter
            // trucchetto per avere i conteggi basati sui filtri in uso
            pars.request.totals = params.totals
            // trucchetto per avere il distinct sui clients basato sui filtri in uso
            pars.request.clients = params.clients
            const response = await Axios.post(`${SERVER}/getSpares`, pars);
            console.log("getSparesServer after post",response.data);
            response.data.success=true
            // if(response.data.lastRow>=0)
            //     response.data.rowCount = response.data.lastRow
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
            return null
        }
    },
    async getSparesServerSold(params) {
        try {
            console.log("getSparesServerSold", params,SERVER);
            let pars = { request: params.request }
            const response = await Axios.post(`${SERVER}/getSparesSold`, pars);
            console.log("getSparesServer after post",response.data);
            response.data.success=true
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
            return null
        }
    },
    async getRepairs(user) {
        try {
            console.log("getRepairs", user);
            const response = await Axios.post(`${SERVER}/getRepairs`, {user});
            response.data.success=true
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
            return null
        }
    },
    async getDebt(client) { // client Code
        try {
            const response = await Axios.get(`${SERVER}/getDebt`, {
                params: { client }
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async setUnit(code,name,location) { // machine Code
        try {
            const response = await Axios.get(`${SERVER}/setUnit`, {
                params: {
                    code, name, location
                }
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getDocs(code) { // machine Code
        try {
            const response = await Axios.get(`${SERVER}/getDocs`, {
                params: {
                    code
                }
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getUnitNames() {
        try {
            const response = await Axios.get(`${SERVER}/getUnitNames`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getPromoMachines() {
        try {
            const response = await Axios.get(`${SERVER}/getPromoMachines`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async updatePromoMachines() {
        try {
            const response = await Axios.get(`${SERVER}/updatePromoMachines`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getBackups(code) { // machine Code
        try {
            const response = await Axios.get(`${SERVER}/getBackups`, {
                params: {
                    code
                }
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    getBckCall(code, file){
        let token = localStorage.getItem("jwt");
        return `${SERVER}/getBck?code=${code}&file=${file}&token=${token}`;
    },
    getDocCall(code, file,zip){
        let token = localStorage.getItem("jwt");
        return `${SERVER}/getDoc?code=${code}&file=${file}&zip=${zip}&token=${token}`;
    },
    async getDoc(code, file,zip) { // client Code, optional
        try {
            const response = await Axios.get(`${SERVER}/getDoc`, {
                params: {
                    code, file, zip
                }
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getClients() {
        try {
            const response = await Axios.get(`${SERVER}/getClients`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getUsers() {
        try {
            const response = await Axios.get(`${SERVER}/getUsers`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getPromoFilters() {
        try {
            const response = await Axios.get(`${SERVER}/promoFilters`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
	// client: opzionale, per filtrare sulle sole promo di un cliente. Se "*" riporta tutte quelle attive
	// all: opzionale, tutte, altrimenti solo quelle attive nel range di date
    async getPromos(client, all) {
        try {
            const response = await Axios.get(`${SERVER}/promos`, { params: { client , all} });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async setPromoFilter(id, filter) {
        try {
            const response = await Axios.post(`${SERVER}/promoFilter`, {
                id,
                json: filter
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async setPromo(p) {
        try {
            const response = await Axios.post(`${SERVER}/promo`, p);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async delPromoFilter(id) {
        try {
            const response = await Axios.get(`${SERVER}/promoFilter`, {
                params: {
                    id
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async delPromo(id) {
        try {
            const response = await Axios.get(`${SERVER}/promo`, { params: { id }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
	async promoCampaignSend(id, fromdate) {
        try {
            const response = await Axios.get(`${SERVER}/promoCampaignSend`, { params: { id, fromdate }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
	},
    async promoCampaignTest(id,email) {
        try {
            const response = await Axios.get(`${SERVER}/promoCampaignTest`, {
                params: {
                    id, email
                },
            });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async updPromoCampaign(id) {
        try {
			const response = await Axios.post(`${SERVER}/promoCampaign`, {id});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getPromoImages(){
        try {
            const response = await Axios.get(`${SERVER}/promoImages`, { });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getIssueApproveData(issueid, status) {
        try {
            const response = await Axios.get(`${SERVER}/pi_getapprove`, { params:{ issueid, status }});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getIssueDoneData(issueid, status) {
        try {
            const response = await Axios.get(`${SERVER}/pi_getdone`, { params:{ issueid, status }});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async pi_approve(agreedwith, description, issueid, status) {
        try {
            const response = await Axios.post(`${SERVER}/pi_approve`, { agreedwith, description, issueid, status });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async pi_done(agreedwith, description, issueid, status) {
        try {
            const response = await Axios.post(`${SERVER}/pi_done`, { agreedwith, description, issueid, status });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async pi_actionapprove(agreedwith, description, actionid, status) {
        try {
            const response = await Axios.post(`${SERVER}/pi_actionapprove`, { agreedwith, description, actionid, status });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async pi_actiondone(agreedwith, description, actionid, status) {
        try {
            const response = await Axios.post(`${SERVER}/pi_actiondone`, { agreedwith, description, actionid, status });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getActionApproveData(actionid, status) {
        try {
            const response = await Axios.get(`${SERVER}/pi_getactionapprove`, { params:{ actionid, status }});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getActionDoneData(actionid, status) {
        try {
            const response = await Axios.get(`${SERVER}/pi_getactiondone`, { params:{ actionid, status }});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async prinIssues(mcode, status, filtro) {
        try {
            const response = await Axios.post(`${SERVER}/pi_issues`, { mcode, status, filtro }, );
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async pi_Actions(issueid, status) {
        try {
            const response = await Axios.get(`${SERVER}/pi_actions`, { params: { issueid, status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getPriorities() {
        try {
            let response = await Axios.get(`${SERVER}/priorities`, {});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getPhases(status) {
        try {
            let response = await Axios.get(`${SERVER}/phases`, { params: { status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getCategories() {
        try {
            let response = await Axios.get(`${SERVER}/categories`, {});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getResponsibles() {
        try {
            let response = await Axios.get(`${SERVER}/responsibles`, {});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getStates() {
        try {
            let response = await Axios.get(`${SERVER}/states`, {});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async addIssue(issue, status) {
        try {
            issue.status = status
            let response = await Axios.post(`${SERVER}/addIssue`, issue);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async cloneIssueActionsAndAttachments(newIssueId, currIssueId, status) {
        try {
            await Axios.get(`${SERVER}/cloneIssueActionsAndAttachments`, { params: { newIssueId, currIssueId, status }});
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async addAction(action, status) {
        try {
            action.status = status
            let response = await Axios.post(`${SERVER}/addAction`, action);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },

    async issueStates(mcode, status, filtro) {
        try {
            let response = await Axios.post(`${SERVER}/issueStates`, { mcode, status,filtro });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async deleteAction(actionid, status) {
        try {
            await Axios.post(`${SERVER}/deleteAction`, { actionid, status });
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async actionStates(issueid, status) {
        try {
            let response = await Axios.post(`${SERVER}/actionStates`, { issueid, status });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async actionMachines(status) {
        try {
            let response = await Axios.get(`${SERVER}/actionMachines`,{ params: { status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async unitLocation(code) {
        try {
            let response = await Axios.get(`${SERVER}/unitlocation`, { params: { code }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async meetings(mcode, which){
        try {
            let response = await Axios.get(`${SERVER}/meetings`, {params:{ mcode, which }});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
            return null
        }
    },
    async addMeeting(title, date, startT, endT, machine, people, description, status){
        try {
            let response = await Axios.post(`${SERVER}/addMeeting`, { title, date, startT, endT, machine, people, description, status });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async availCodes() {
        try {
            let response = await Axios.get(`${SERVER}/availCodes`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async unitLocationAdd(code,startdate,location,status) {
        try {
            let response = await Axios.get(`${SERVER}/unitlocationadd`, { params: { code,startdate,location,status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async unitLocationDel(code,startdate) {
        try {
            let response = await Axios.get(`${SERVER}/unitlocationdel`, { params: { code,startdate }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async locations() {
        try {
            let response = await Axios.get(`${SERVER}/locations`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async piAddThread(unitCode,name,users,status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_addThread`, { params: { unitCode,name,users:users.join(","),status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async piEditThread(id,name,users,status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_updThread`, { params: { id,name,users:users.join(","),status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async piDeleteThread(id,status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_delThread`, { params: { id,status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async piSearchThreads(unitCode, status, val) {
        try {
            let response = await Axios.get(`${SERVER}/pi_searchThreads`, { params: { unitCode,status,val }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async piGetThreads(unitCode,status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_getThreads`, { params: { unitCode,status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getRoles() {
        try {
            let response = await Axios.get(`${SERVER}/getRoles`);
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getAvailUsers(unitCode, marsilli) {
        try {
            let response = await Axios.get(`${SERVER}/getAvailUsers`, { params: { unitCode, marsilli }, });
            return response.data;
        }
        catch (e) {
            console.error("ERR:", e);
        }
    },
    async getTeams(unitCode, status) {
        try {
            let response = await Axios.get(`${SERVER}/getTeams`, { params: { unitCode, status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async piDeleteTeamMember(unitCode, userId, status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_delTeamMember`, { params: { unitCode,userId,status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async piAddTeamMember(unitCode, userId, roleId, status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_addTeamMember`, { params: { unitCode,userId,roleId, status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getPMs(status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_getPMs`, { params: { status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getCustomers(status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_getCustomers`, { params: { status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getKNumbers(status) {
        try {
            let response = await Axios.get(`${SERVER}/pi_getKNumbers`, { params: { status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    
    async expiringIssues(mcode, status, filtro) {
        try {
            let response = await Axios.post(`${SERVER}/expiringIssues`, { mcode, status, filtro }, );
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async threadmsgs(status,threadid) {
        try {
            let response = await Axios.get(`${SERVER}/threadmsgs`, { params: { threadid, status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async lastthreadmsgs( status, filtro ) {
        try {
            let response = await Axios.post(`${SERVER}/lastthreadmsgs`, { status, filtro });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async threadmsgSend(threadid, da, attachment_id, message, status) {
        try {
            let response = await Axios.post(`${SERVER}/threadmsgSend`, { threadid, da, attachment_id, message, status });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async chat(status, mcode, issueid, actionid) {
        try {
            let response = await Axios.get(`${SERVER}/chat`, { params: { mcode, issueid, actionid, status }, });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async chatSend(mcode, issueid, actionid, da, attachment_id, message, status) {
        try {
            let response = await Axios.post(`${SERVER}/chatSend`, { mcode, issueid, actionid, da, attachment_id, message, status });
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    async getDocuments(contest, mcode, issueid, actionid) {
        console.log("getDocuments", contest, mcode, issueid, actionid);
        try {
            let response = await Axios.get(`${SERVER}/getDocuments`, {params:{ contest, mcode, issueid, actionid }});
            return response.data;
        } catch (e) {
            console.error("ERR:", e);
        }
    },
    getAttachLink(code, file, issueid, actionid) {
        return `${SERVER}/getAttach?code=${code}&file=${file}&issueid=${issueid}&actionid=${actionid}&token=${localStorage.getItem("jwt")}`;
    }
    
};
